import { ref, onMounted } from "vue";
import { carDataUtils } from "@/utils/carData";

export function useVehicleData() {
  const makes = ref([]);
  const models = ref([]);
  const loading = ref(false);
  const error = ref(null);

  const fetchMakes = async () => {
    try {
      loading.value = true;
      // Use local car data instead of API
      makes.value = carDataUtils.getAllMakes();
    } catch (err) {
      error.value = "Failed to fetch vehicle makes.";
      console.error(err);
    } finally {
      loading.value = false;
    }
  };

  const fetchModelsForMake = async (makeName) => {
    try {
      loading.value = true;
      // Use local car data instead of API
      models.value = carDataUtils.getModelsForMake(makeName);
    } catch (err) {
      error.value = `Failed to fetch models for make "${makeName}".`;
      console.error(err);
    } finally {
      loading.value = false;
    }
  };

  const searchMakeModels = (query) => {
    return carDataUtils.searchMakeModels(query);
  };

  const getPopularModelsForMake = (makeName) => {
    return carDataUtils.getPopularModelsForMake(makeName);
  };

  const getAllMakeModels = () => {
    return carDataUtils.getAllMakeModels();
  };

  onMounted(() => {
    fetchMakes();
  });

  return {
    makes,
    models,
    loading,
    error,
    fetchMakes,
    fetchModelsForMake,
    searchMakeModels,
    getPopularModelsForMake,
    getAllMakeModels
  };
}